import React from 'react'
import {
  Button,
  Col,
  Row,
  Table
} from "reactstrap"
import MainService from '../../../../Services/MainService';
import moment from 'moment';
import { useSelector } from 'react-redux';

export default function LevelThreeRequirements(props) {

  const { data, setZoomImagePath, countries, currencies, payoutMethods } = props;
  const { accountTypes, routingTypes } = useSelector(state => state.Main);

  const viewProof = (path) => {
    if (MainService.getFxtensions(path) === "image") {
      setZoomImagePath(path)
    } else {
      window.open(path, "_blank")
    }
  }

  return (data.levelThree ?

    <Col sm={12}>
      <Row>
        <Col sm={6}>
          <Table bordered striped responsive className='mb-0'>
            <tbody>
              <tr>
                <th
                  scope="row"
                  style={{ width: "400px" }}
                  className={"text-capitalize"}
                >
                  Status
                </th>
                <td className='w-50'>
                  <span className={`badge badge-soft-${data.levelThree?.isApproved ? "success" : "danger"} font-size-14 badge badge-pill`}>
                    {data.levelThree?.isApproved ? "Active" : "Inactive"}
                  </span>
                </td>
              </tr>
              <tr>
                <th
                  scope="row"
                  style={{ width: "400px" }}
                  className={"text-capitalize"}
                >
                  Account Name
                </th>
                <td className='w-50'>{data.levelThree?.accountName ? data.levelThree?.accountName : <span className='text-danger'>Not set</span>}</td>
              </tr>

              <tr>
                <th
                  scope="row"
                  style={{ width: "400px" }}
                  className={"text-capitalize"}
                >
                  Account Number
                </th>
                <td className='w-50'>{data.levelThree?.accountNumber ? data.levelThree?.accountNumber : <span className='text-danger'>Not set</span>}</td>
              </tr>
              <tr>
                <th
                  scope="row"
                  style={{ width: "400px" }}
                  className="text-capitalize"
                >
                  Account Type
                </th>
                {accountTypes && accountTypes.libraryData && accountTypes.libraryData.length ? (
                  (() => {
                    const found = accountTypes.libraryData.find(
                      (item) => item.id === data.levelThree?.accountType
                    );
                    return (
                      <td className="w-50">
                        {found ? found.displayName : <span className="text-danger">Not set</span>}
                      </td>
                    );
                  })()
                ) : (
                  <td className="w-50">
                    <span className="text-danger">Not set</span>
                  </td>
                )}
              </tr>
              <tr>
                <th
                  scope="row"
                  style={{ width: "400px" }}
                  className="text-capitalize"
                >
                  Routing Type
                </th>
                {routingTypes && routingTypes.libraryData && routingTypes.libraryData.length ? (
                  (() => {
                    const found = routingTypes.libraryData.find(
                      (item) => item.id === data.levelThree?.routingTypeLibraryDataId
                    );
                    return (
                      <td className="w-50">
                        {found ? found.displayName : <span className="text-danger">Not set</span>}
                      </td>
                    );
                  })()
                ) : (
                  <td className="w-50">
                    <span className="text-danger">Not set</span>
                  </td>
                )}
              </tr>
              <tr>
                <th
                  scope="row"
                  style={{ width: "400px" }}
                  className={"text-capitalize"}
                >
                  ABA Routing Number
                </th>
                <td className='w-50'>{data.levelThree?.routingValue ? data.levelThree?.routingValue : <span className="text-danger">Not set</span>}</td>
              </tr>
              <tr>
                <th
                  scope="row"
                  style={{ width: "400px" }}
                  className="text-capitalize"
                >
                  Country
                </th>
                {countries && countries.length ? (
                  (() => {
                    const found = countries.find(
                      (item) => item.id === data.levelThree?.countryId
                    );
                    return (
                      <td className="w-50">
                        {found ? found.name : <span className="text-danger">Not set</span>}
                      </td>
                    );
                  })()
                ) : (
                  <td className="w-50">
                    <span className="text-danger">Not set</span>
                  </td>
                )}
              </tr>
              <tr>
                <th
                  scope="row"
                  style={{ width: "400px" }}
                  className={"text-capitalize"}
                >
                  City
                </th>
                <td className='w-50'>{data.levelThree?.city ? data.levelThree?.city : <span className="text-danger">Not set</span>}</td>
              </tr>
              <tr>
                <th
                  scope="row"
                  style={{ width: "400px" }}
                  className={"text-capitalize"}
                >
                  State/Province
                </th>
                <td className='w-50'>{data.levelThree?.province ? data.levelThree?.province : <span className="text-danger">Not set</span>}</td>
              </tr>

              <tr>
                <th
                  scope="row"
                  style={{ width: "400px" }}
                  className={"text-capitalize"}
                >
                  Swift Code
                </th>
                <td className='w-50'>{data.levelThree?.swiftCode ? data.levelThree?.swiftCode : <span className="text-danger">Not set</span>}</td>
              </tr>

            </tbody>
          </Table>
        </Col>
        <Col sm={6}>
          <Table bordered striped responsive className='mb-0'>
            <tbody>
              <tr>
                <th
                  scope="row"
                  style={{ width: "400px" }}
                  className={"text-capitalize"}
                >
                  Bank Name
                </th>
                <td className='w-50'>{data.levelThree?.bankName ? data.levelThree?.bankName : <span className="text-danger">Not set</span>}</td>
              </tr>
              <tr>
                <th
                  scope="row"
                  style={{ width: "400px" }}
                  className={"text-capitalize"}
                >
                  Bank Code
                </th>
                <td className='w-50'>{data.levelThree?.bankCode ? data.levelThree?.bankCode : <span className="text-danger">Not set</span>}</td>
              </tr>
              <tr>
                <th
                  scope="row"
                  style={{ width: "400px" }}
                  className={"text-capitalize"}
                >
                  Bank Address
                </th>
                <td className='w-50'>{data.levelThree?.bankAddress ? data.levelThree?.bankAddress : <span className="text-danger">Not set</span>}</td>
              </tr>
              <tr>
                <th
                  scope="row"
                  style={{ width: "400px" }}
                  className={"text-capitalize"}
                >
                  Branch Code
                </th>
                <td className='w-50'>{data.levelThree?.branchCode ? data.levelThree?.branchCode : <span className="text-danger">Not set</span>}</td>
              </tr>
              <tr>
                <th
                  scope="row"
                  style={{ width: "400px" }}
                  className={"text-capitalize"}
                >
                  Payout Method
                </th>
                {payoutMethods && payoutMethods.length ? (
                  (() => {
                    const found = payoutMethods.find(
                      (item) => item.id === data.levelThree?.paymentMethodLibraryDataId
                    );
                    return (
                      <td className="w-50">
                        {found ? found.displayName : <span className="text-danger">Not set</span>}
                      </td>
                    );
                  })()
                ) : (
                  <td className="w-50">
                    <span className="text-danger">Not set</span>
                  </td>
                )}
              </tr>
              <tr>
                <th
                  scope="row"
                  style={{ width: "400px" }}
                  className={"text-capitalize"}
                >
                  Currency
                </th>
                {currencies && currencies.length ? (
                  (() => {
                    const found = currencies.find(
                      (item) => item.id === data.levelThree?.currencyId
                    );
                    return (
                      <td className="w-50">
                        {found ? found.name : <span className="text-danger">Not set</span>}
                      </td>
                    );
                  })()
                ) : (
                  <td className="w-50">
                    <span className="text-danger">Not set</span>
                  </td>
                )}
              </tr>
              <tr>
                <th
                  scope="row"
                  style={{ width: "400px" }}
                  className={"text-capitalize"}
                >
                  {data.levelThree?.holderTypeLibrary?.displayName || "Holder type"}
                </th>
                {data.levelThree?.holderTypeLibrary?.libraryData &&
                  data.levelThree.holderTypeLibrary.libraryData.length ? (
                  (() => {
                    const found = data.levelThree.holderTypeLibrary.libraryData.find(
                      (item) => item.id === data.levelThree?.holderTypeLibraryDataId
                    );
                    return (
                      <td className="w-50">
                        {found ? found.displayName : <span className="text-danger">Not set</span>}
                      </td>
                    );
                  })()
                ) : (
                  <td className="w-50">
                    <span className="text-danger">Not set</span>
                  </td>
                )}

              </tr>
              <tr>
                <th
                  scope="row"
                  style={{ width: "400px" }}
                  className={"text-capitalize"}
                >
                  iBan
                </th>
                <td className='w-50'>{data.levelThree?.iBan ? data.levelThree?.iBan : <span className="text-danger">Not set</span>}</td>
              </tr>
              <tr>
                <th
                  scope="row"
                  style={{ width: "400px" }}
                  className={"text-capitalize"}
                >
                  Create Date
                </th>
                <td className='w-50'>
                  {data.levelThree?.createTime ? moment(MainService.convertUTCDateToLocalDate(new Date(data.levelThree?.createTime))).format("LL HH:mm") : <span className="text-danger">Not set</span>}
                </td>
              </tr>
              <tr>
                <th
                  scope="row"
                  style={{ width: "400px" }}
                  className={"text-capitalize"}
                >
                  Last Update
                </th>
                <td className='w-50'>
                  {data.levelThree?.updateTime ? moment(MainService.convertUTCDateToLocalDate(new Date(data.levelThree?.updateTime))).format("LL HH:mm") : <span className="text-danger">Not set</span>}
                </td>
              </tr>
            </tbody>
          </Table>
        </Col>
      </Row>
    </Col>
    : null
  )
}
